export class ITab {
  constructor({ name = +new Date(), path = '', fullPath = '', query = {}, meta = {} }) {
    this.name = name;
    this.path = path;
    this.fullPath = fullPath;
    this.query = { ...query };
    this.meta = { ...meta };

    this.title = meta.title || '未命名标签';
  }
}

export default {
  namespaced: true,

  state: {
    openedTabs: [],
    activeTabName: ''
  },

  getters: {
    currentTab: state => tabName => state.openedTabs.find(tab => tab.name === tabName),
    activeTab: (state, getters) => getters.currentTab(state.activeTabName)
  },

  mutations: {
    SET_ACTIVE_TAB(state, tabName) {
      state.activeTabName = tabName;
    },
    ADD_TAB(state, tab) {
      state.openedTabs.push(tab);
    },
    REMOVE_TAB(state, tabName) {
      const tabIndex = state.openedTabs.findIndex(tab => tab.name === tabName);
      state.openedTabs.splice(tabIndex, 1);
    },
    CLEAR_TAB(state){
      state.openedTabs = [];
    }
  },

  actions: {
    async setActiveTab({ commit }, tabName) {
      commit('SET_ACTIVE_TAB', tabName);
    },
    async addTab({ commit }, tabView) {
      commit('ADD_TAB', new ITab(tabView));
    },
    async removeTab({ commit }, tabName) {
      commit('REMOVE_TAB', tabName);
    },
    async clearTab({ commit }) {
      commit('CLEAR_TAB');
    }
  }
};
